//
//
//
//
//
//
//
//
//

export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        input: (event) => {
          this.$emit('input', event.target.checked)
        }
      }
    }
  }
}
